export const LogoMark = ({ className = "h-5 w-auto" }) => (
  <img src="/brand/newland-roofs-light.png" alt="" aria-hidden="true" className={className} draggable={false} />
);

export const Logo = ({ className = "h-11 w-auto md:h-12" }) => (
  <img src="/brand/newland-logo-light.png" alt="Newland Construction" className={className} draggable={false} />
);
